/**
 * @packageDocumentation
 * @module HackerAPI.User.RoleList
 */
import { __extends } from "tslib";
import Sponsor from "../sponsor/sponsor";
import Mentor from "../mentor/mentor";
import Hacker from "../hacker/hacker";
import Base from "../../base/base";
/**
 * A data container for all the roles that a user can take on
 * @class
 * @extends { HackerAPI.Base }
 */
var RoleList = /** @class */ (function (_super) {
    __extends(RoleList, _super);
    /**
     * Creates a new RoleList instance
     * @constructor
     * @param roleList
     */
    function RoleList(_a) {
        var _b = _a === void 0 ? {} : _a, sponsor = _b.sponsor, mentor = _b.mentor, hacker = _b.hacker;
        var _this = _super.call(this) || this;
        /**
         * Sponsor data of the user
         * @type { HackerAPI.User.Sponsor }
         */
        _this.sponsor = (sponsor && new Sponsor(sponsor)) || null;
        /**
         * Mentor data of the user
         * @type { HackerAPI.User.Mentor }
         */
        _this.mentor = (mentor && new Mentor(mentor)) || null;
        /**
         * Hacker data of the user
         * @type { HackerAPI.User.Hacker }
         */
        _this.hacker = (hacker && new Hacker(hacker)) || null;
        return _this;
    }
    return RoleList;
}(Base));
export default RoleList;
//# sourceMappingURL=role-list.js.map